import React from "react";
import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../redux/store";
import { setSelectedTemplate } from "../../../features/template/template.slice";
import { resetNodesState } from "../../../redux/features/nodes";

const options = [
  {
    label: "1 BHK",
    description: "1 Bedroom, 1 Living Room, 1 Kitchen, 1 Bathroom",
    value: "1bhk",
  },
  {
    label: "2 BHK",
    description: "2 Bedrooms, 1 Living Room, 1 Kitchen, 1 Bathroom",
    value: "2bhk",
  },
  {
    label: "3 BHK",
    description: "3 Bedrooms, 1 Living Room, 1 Kitchen, 2 Bathrooms",
    value: "3bhk",
  },
  {
    label: "Blank Document",
    description: "Start from scratch with no predefined rooms",
    value: "blank",
  },
];

const HousingTemplatePage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();

  const handleSelect = (value: string) => {
    dispatch(resetNodesState());
    if (value === "blank") {
      dispatch(setSelectedTemplate("housing"));
      navigate("/inputeditor");
    } else {
      dispatch(setSelectedTemplate("housing"));
      navigate("/inputeditor", { state: { bhkType: value } });
    }
  };

  return (
    <Box
      sx={{
        width: "100vw",
        height: "100vh",
        backgroundColor: "#FBE5C6",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 4,
      }}
    >
      <Typography
        sx={{
          fontFamily: "Poppins",
          fontSize: "28px",
          fontWeight: 700,
          color: "#FF9A56",
        }}
      >
        Select Housing Template
      </Typography>

      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: 3,
          flexWrap: "wrap",
          justifyContent: "center",
        }}
      >
        {options.map((option) => (
          <Box
            key={option.value}
            onClick={() => handleSelect(option.value)}
            sx={{
              width: "220px",
              height: "180px",
              backgroundColor: "white",
              borderRadius: "16px",
              border: "2px solid #1a1a1a",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              gap: 2,
              padding: "20px",
              // boxShadow: "4px 4px 0px #1a1a1a",
              transition: "all 0.15s ease",
              "&:hover": {
                transform: "translate(-2px, -2px)",
                // boxShadow: "6px 6px 0px #1a1a1a",
                backgroundColor: "#FF9A56",
                "& .option-label": { color: "#1a1a1a" },
                "& .option-desc": { color: "#1a1a1a" },
              },
              "&:active": {
                transform: "translate(1px, 1px)",
                // boxShadow: "2px 2px 0px #1a1a1a",
              },
            }}
          >
            <Typography
              className="option-label"
              sx={{
                fontFamily: "Poppins",
                fontSize: "22px",
                fontWeight: 700,
                color: "#FF9A56",
                transition: "color 0.2s",
              }}
            >
              {option.label}
            </Typography>
            <Typography
              className="option-desc"
              sx={{
                fontFamily: "Poppins",
                fontSize: "12px",
                fontWeight: 400,
                color: "#666",
                textAlign: "center",
                transition: "color 0.2s",
              }}
            >
              {option.description}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default HousingTemplatePage;